<template>
  <v-container fluid>
    <material-card
      class="vertical-align-top"
      icon="mdi-clipboard-text"
      inline
      title="Week Schedule"
    >
      <v-card flat class="px-2"> </v-card>
      <v-card-actions>
        <a @click="$router.back()">
          <v-btn
            v-if="$vuetify.breakpoint.smAndUp"
            elevation="1"
            absolute
            right
            top
          >
            <v-icon left>mdi-arrow-left</v-icon>back
          </v-btn>
          <v-btn
            v-else
            fixed
            right
            fab
            small
            color="grey lighten-2"
            elevation="1"
            class="mr-n2 mt-10"
            style="opacity: 0.6"
          >
            <v-icon>mdi-arrow-left</v-icon>
          </v-btn>
        </a>
      </v-card-actions>
      <v-card-component>
        <v-card-text
          class="pt-0 pr-1"
          :class="{
            'd-block py-3': $vuetify.breakpoint.xs,
            'd-flex align-center': $vuetify.breakpoint.smAndUp
          }"
        >
          <v-card-title>
            <v-icon color="primary" elevation="1" left
              >mdi-library-books</v-icon
            >
            {{ this.weekList[0].themeName }}
            <v-spacer></v-spacer>
          </v-card-title>
        </v-card-text>
        <v-divider class="my-0" />
        <v-data-table
          item-key="name"
          :headers="headers"
          :items="weekScheduleList"
          disable-pagination
          hide-default-footer
        >
          <template v-slot:header.DAY_1="{ header }">
            <router-link
              :to="{
                name: 'addWeekSchedule',
                params: {
                  folderId: folderId,
                  dayID: dayArray.DAY_1
                    ? dayArray.DAY_1.dayID || dayArray.DAY_1.dayName
                    : null,
                  day: dayArray.DAY_1 ? dayArray.DAY_1.dayName || null : null
                }
              }"
            >
              <v-btn variant="text">
                {{ header.text }} &nbsp; <v-icon left>mdi-pencil</v-icon>
              </v-btn>
            </router-link>
          </template>
          <template v-slot:header.DAY_2="{ header }">
            <router-link
              :to="{
                name: 'addWeekSchedule',
                params: {
                  folderId: folderId,
                  dayID: dayArray.DAY_2
                    ? dayArray.DAY_2.dayID || dayArray.DAY_2.dayName
                    : null,
                  day: dayArray.DAY_2 ? dayArray.DAY_2.dayName || null : null
                }
              }"
            >
              <v-btn variant="text">
                {{ header.text }} &nbsp;
                <v-icon elevation="1" left>mdi-pencil</v-icon>
              </v-btn>
            </router-link>
          </template>
          <template v-slot:header.DAY_3="{ header }">
            <router-link
              :to="{
                name: 'addWeekSchedule',
                params: {
                  folderId: folderId,
                  dayID: dayArray.DAY_3
                    ? dayArray.DAY_3.dayID || dayArray.DAY_3.dayName
                    : null,
                  day: dayArray.DAY_3 ? dayArray.DAY_3.dayName || null : null
                }
              }"
            >
              <v-btn variant="text">
                {{ header.text }} &nbsp;
                <v-icon elevation="1" left>mdi-pencil</v-icon>
              </v-btn>
            </router-link>
          </template>
          <template v-slot:header.DAY_4="{ header }">
            <router-link
              :to="{
                name: 'addWeekSchedule',
                params: {
                  folderId: folderId,
                  dayID: dayArray.DAY_4
                    ? dayArray.DAY_4.dayID || dayArray.DAY_4.dayName
                    : null,
                  day: dayArray.DAY_4 ? dayArray.DAY_4.dayName || null : null
                }
              }"
            >
              <v-btn variant="text">
                {{ header.text }} &nbsp;
                <v-icon elevation="1" left>mdi-pencil</v-icon>
              </v-btn>
            </router-link>
          </template>
          <template v-slot:header.DAY_5="{ header }">
            <router-link
              :to="{
                name: 'addWeekSchedule',
                params: {
                  folderId: folderId,
                  dayID: dayArray.DAY_5
                    ? dayArray.DAY_5.dayID || dayArray.DAY_5.dayName
                    : null,
                  day: dayArray.DAY_5 ? dayArray.DAY_5.dayName || null : null
                }
              }"
            >
              <v-btn variant="text">
                {{ header.text }} &nbsp;
                <v-icon elevation="1" left>mdi-pencil</v-icon>
              </v-btn>
            </router-link>
          </template>
          <template v-slot:header.DAY_6="{ header }">
            <router-link
              :to="{
                name: 'addWeekSchedule',
                params: {
                  folderId: folderId,
                  dayID: dayArray.DAY_6
                    ? dayArray.DAY_6.dayID || dayArray.DAY_6.dayName
                    : null,
                  day: dayArray.DAY_6 ? dayArray.DAY_6.dayName || null : null
                }
              }"
            >
              <v-btn variant="text">
                {{ header.text }} &nbsp;
                <v-icon elevation="1" left>mdi-pencil</v-icon>
              </v-btn>
            </router-link>
          </template>
          <template v-slot:item.DAY_1="{ item }" style="vertical-align: center">
            <v-row
              multiline
              no-gutters
              v-for="schedule in item.DAY_1.daySchedule"
              :key="schedule.id"
            >
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <div
                    class="text-button mb-1"
                    v-text="
                      schedule.theme
                        ? `${schedule.theme} - (${
                            schedule.themeTime || 0
                          } Min.) `
                        : '-'
                    "
                  ></div>
                </v-col>
                <v-col cols="12" md="6" sm="12">
                  <router-link
                    :to="{
                      name: 'viewDayScheduleList',
                      params: { dayId: schedule.id }
                    }"
                  >
                    <v-btn variant="text">
                      {{ schedule.title || '-' }}
                    </v-btn>
                  </router-link>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <router-link
                    :to="{
                      name: 'editIndividualDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                    <v-btn variant="outlined" size="large" icon color="info">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </router-link>
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                  </router-link>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-row>
          </template>
          <template v-slot:item.DAY_2="{ item }" style="vertical-align: top">
            <v-row
              no-gutters
              v-for="schedule in item.DAY_2.daySchedule"
              :key="schedule.id"
              style="vertical-align: top"
            >
              <v-row>
                <v-col cols="12" md="12" sm="12" style="vertical-align: top">
                  <div
                    class="text-button mb-1"
                    v-text="
                      schedule.theme
                        ? `${schedule.theme} - (${
                            schedule.themeTime || 0
                          } Min.) `
                        : '-'
                    "
                  ></div>
                </v-col>
                <v-col cols="12" md="8" sm="12">
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                    <v-btn variant="text">
                      {{ schedule.title || '-' }}
                    </v-btn>
                  </router-link>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                    <v-btn variant="outlined" size="large" icon color="info">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </router-link>
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                  </router-link>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-row>
          </template>
          <template v-slot:item.DAY_3="{ item }">
            <v-row
              multiline
              no-gutters
              v-for="schedule in item.DAY_3.daySchedule"
              :key="schedule.id"
            >
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <div
                    class="text-button mb-1"
                    v-text="
                      schedule.theme
                        ? `${schedule.theme} - (${
                            schedule.themeTime || 0
                          } Min.) `
                        : '-'
                    "
                  ></div>
                </v-col>
                <v-col cols="12" md="8" sm="12">
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                    <v-btn variant="text">
                      {{ schedule.title || '-' }}
                    </v-btn>
                  </router-link>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                    <v-btn variant="outlined" size="large" icon color="info">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </router-link>
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                  </router-link>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-row>
          </template>
          <template v-slot:item.DAY_4="{ item }">
            <v-row
              multiline
              no-gutters
              v-for="schedule in item.DAY_4.daySchedule"
              :key="schedule.id"
            >
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <div
                    class="text-button mb-1"
                    v-text="
                      schedule.theme
                        ? `${schedule.theme} - (${
                            schedule.themeTime || 0
                          } Min.) `
                        : '-'
                    "
                  ></div>
                </v-col>
                <v-col cols="12" md="8" sm="12">
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                    <v-btn variant="text">
                      {{ schedule.title || '-' }}
                    </v-btn>
                  </router-link>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                    <v-btn variant="outlined" size="large" icon color="info">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </router-link>
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                  </router-link>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-row>
          </template>
          <template v-slot:item.DAY_5="{ item }">
            <v-row
              multiline
              no-gutters
              v-for="schedule in item.DAY_5.daySchedule"
              :key="schedule.id"
            >
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <div
                    class="text-button mb-1"
                    v-text="
                      schedule.theme
                        ? `${schedule.theme} - (${
                            schedule.themeTime || 0
                          } Min.) `
                        : '-'
                    "
                  ></div>
                </v-col>
                <v-col cols="12" md="8" sm="12">
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                    <v-btn variant="text">
                      {{ schedule.title || '-' }}
                    </v-btn>
                  </router-link>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                    <v-btn variant="outlined" size="large" icon color="info">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </router-link>
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                  </router-link>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-row>
          </template>
          <template v-slot:item.DAY_6="{ item }">
            <v-row
              multiline
              no-gutters
              v-for="schedule in item.DAY_6.daySchedule"
              :key="schedule.id"
            >
              <v-row>
                <v-col cols="12" md="12" sm="12">
                  <div
                    class="text-button mb-1"
                    v-text="
                      schedule.theme
                        ? `${schedule.theme} - (${
                            schedule.themeTime || 0
                          } Min.) `
                        : '-'
                    "
                  ></div>
                </v-col>
                <v-col cols="12" md="8" sm="12">
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                    <v-btn variant="text">
                      {{ schedule.title || '-' }}
                    </v-btn>
                  </router-link>
                </v-col>
                <v-col cols="12" md="4" sm="12">
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                    <v-btn variant="outlined" size="large" icon color="info">
                      <v-icon>mdi-pencil</v-icon>
                    </v-btn>
                  </router-link>
                  <router-link
                    :to="{
                      name: 'addDaySchedule',
                      params: { dayId: schedule.id }
                    }"
                  >
                  </router-link>
                </v-col>
              </v-row>
              <v-divider></v-divider>
            </v-row>
          </template>
        </v-data-table>
      </v-card-component>
    </material-card>
  </v-container>
</template>

<script src="/build/qrcode.min.js"></script>
<script lang="en">
import CONSTANTS from '@/utils/constants'
import _ from 'lodash'
import MaterialCard from '@/components/template/MaterialCard'
import VCardComponent from '@/components/template/VCardComponent'

export default {
  components: { VCardComponent, MaterialCard },
  props: ['folderId'],
  data () {
    return {
      weekScheduleList: [],
      theme: '',
      dayArray:{},
      newData: [],
      item: [],
      weekList: [
        {
          themeName: ''
        }
      ],
      search: '',
      headers: [
        { text: 'DAY 1', name:'DAY_1', value: 'DAY_1', width: '20%',align: 'center', icon:'person',sortable:false },
        { text: 'DAY 2',  name: 'DAY_2',value: 'DAY_2', width: '20%', align: 'center' , icon:'person',sortable:false },
        { text: 'DAY 3',  name: 'DAY_3',value: 'DAY_3', width: '20%', align: 'center', icon:'person' ,sortable:false },
        { text: 'DAY 4', name: 'DAY_4', value: 'DAY_4', width: '20%', align: 'center', icon:'person' ,sortable:false },
        { text: 'DAY 5',  name: 'DAY_5',value: 'DAY_5', width: '20%', align: 'center', icon:'person' ,sortable:false },
        { text: 'DAY 6',  name: 'DAY_6',value: 'DAY_6', width: '20%', align: 'center', icon:'person' ,sortable:false }
      ]
    }
  },
  created: async function () {
    for (let day of this.headers) {
             let dayName = day.text.replace(' ', '_')
             this.dayArray[dayName]={
              folderID:this.folderId,
              dayID:dayName,
              day:day.text}
           }
    await this.getWeekScheduleList()
    await this.modifyHeaders()
  },
  watch: {},
  methods: {
    modifyHeaders: async function () {
      let res = await http.get(
        `${CONSTANTS.API_URL}/api/curriculum_cms/get-week/${this.folderId}`
      )
      if (res.data.success !== 200) {
        return
      }
      if (!res.data.weekAtGlance.length) {
        return
      }
      res.data = res.data.weekAtGlance.sort(function (a, b) {
        return a.dayName.localeCompare(b.dayName)
      })
      res.data.forEach((item, index) => {
        this.headers[index].id = item.id
      })
    },
    getWeekScheduleList: async function () {
      try {
        this.isLoading = true
        let res = await http.get(
          `${CONSTANTS.API_URL}/api/curriculum_cms/get-week/${this.folderId}`
        )

        if (res.data.success !== 200 || !res.data.weekAtGlance.length) {
              return
        }
        this.weekList = res.data.weekAtGlance
        var days = res.data.weekAtGlance
        days = days.sort(function (a, b) {
          return a.dayName.localeCompare(b.dayName)
        })
        let row = {}

        for (let day of this.headers) {
          let dayName = day.text.replace(' ', '_')
          let dayData = days.find(
            (obj) => obj.dayName.toLowerCase() === day.text.toLowerCase()
          )
          let daySchedule = []
          if (dayData && dayData.weekDay.length) {
            this.dayArray[dayName]={
              folderID:this.folderId,
              dayID:dayData.id,
              day:dayData.dayName || day.text}
            dayData.weekDay = _.orderBy(dayData.weekDay, 'position', 'asc')
            for (let schedule of dayData.weekDay) {
              daySchedule.push({
                id: schedule.id,
                theme: schedule.theme,
                themeTime: schedule.themeTime,
                title: schedule.title,
                position: schedule.position
              })
            }
            row[dayName] = {id:day,daySchedule:daySchedule}
          } else {
            row[dayName] = {}
            this.dayArray[dayName]={
              folderID:this.folderId,
              dayID:dayName,
              day:day.text}
          }
        }
        this.weekScheduleList = [row]
      } catch (e) {
        const errorMessage =
          (e && e.response && e.response.data.message) || e.message
        this.errMsg(errorMessage)
      } finally {
        this.isLoading = false
      }
    },
    okMsg (msg) {
      return this.$dialog.info({
        text: msg,
        title: 'Success'
      })
    },
    errMsg (msg) {
      return this.$dialog.error({
        text: msg,
        title: 'Error'
      })
    }
  }
}
</script>
<style>
#subTable {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  justify-self: center;
  width: 100%;
  height: 100%;
}

#subTable td,
#subTable th {
  border: 1px solid #ddd;
  padding: 1px;
}

#subTable th {
  padding-top: 2px;
  padding-bottom: 2px;
  text-align: left;
  background-color: #04aa6d;
  color: white;
  width: 100%;
}
#subTable td {
  padding-top: 2px;
  padding-bottom: 2px;
  text-align: center;
  width: 100%;
}
.hr_yellow {
  background-color: #ebc784;
  height: 0.9rem;
}
</style>
